
import { useEffect } from 'react';

export const useImagePreview = (
  coverFile: File | null,
  setPreviewUrl: (url: string | null) => void
) => {
  // Generate preview when file is selected
  useEffect(() => {
    if (coverFile) {
      console.log(`Creating preview for file: ${coverFile.name}`);
      const objectUrl = URL.createObjectURL(coverFile);
      setPreviewUrl(objectUrl);

      // Clean up the URL object when the component unmounts or when file changes
      return () => {
        console.log(`Revoking object URL: ${objectUrl}`);
        URL.revokeObjectURL(objectUrl);
      };
    }
    // Note: We intentionally don't do anything when coverFile is null
    // because that's handled by the form component directly
  }, [coverFile, setPreviewUrl]);
};
